// extracted by mini-css-extract-plugin
export default {"button":"Button_button__1Bvcj","primary":"Button_primary__QAmMf","padding":"Button_padding__zppkR","secondary":"Button_secondary__xc+uy","text":"Button_text__35149"};